import styled from 'styled-components'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

import Button from 'src/components/Button'
import { updateTopDisplays } from 'src/lib/controller'
import {
	loadingCustomToast,
	getErrorCustomToast,
	TOAST_DURATION,
	Backdrop,
} from 'src/components/Toaster'
import { Container, Title, Description, Highlight } from './index'


const Advertising = ({ setShowToastBackdrop }) => {
	// const navigate = useNavigate()

	const updateDisplays = () => {
		setShowToastBackdrop(true)
		const update = updateTopDisplays()
		toast.promise(update, {
			loading: loadingCustomToast,
			success: () => {
				setTimeout(() => setShowToastBackdrop(false), TOAST_DURATION)
				return 'Updated displays!'
			},
			error: (error) => {
				setTimeout(() => setShowToastBackdrop(false), TOAST_DURATION)
				return getErrorCustomToast(error)
			},
		})
	}

	return (
		<>
			<Container>
				<Title>Advertise effortlessly, <Highlight>with one click</Highlight></Title>
				<StyledDescription>
					See Micromart™ Smart Store displays update in real time.
				</StyledDescription>
				<Button onClick={updateDisplays}>
					See it live
				</Button>
				<VideoContainer>
					<Video
						src="https://cdn.prod.website-files.com/66d10f2f9108642818b7a365/6712b413e843ab5a683006ad_Marketing-Platform-UI.gif"
						width="60%"
						height="100%"
						style={{
							position: 'absolute',
							bottom: -196,
							objectFit: 'contain',
						}}
					/>
				</VideoContainer>
			</Container>
			{/* {showToastBackdrop && <Backdrop />} */}
		</>
	)
}

const StyledDescription = styled(Description)`
	padding: 0 100px;
`

const VideoContainer = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	z-index: -1;
	display: flex;
	justify-content: center;
`

const Video = styled.img``

export default Advertising
